import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { AuthService } from "src/app/auth.service";
import { singleSystem } from "./system";
import { RoomEntity } from "../design/design.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SystemService {
  private baseURL = environment.baseUrl;

  constructor(private http: HttpClient, private auth: AuthService) {}

  /**
   * Get System List
   * @returns
   */
  getSystemList() {
    return this.http.get(
      `${this.baseURL}/rhAPI/systems/${
        this.auth.getContractorInfo().designer_id
      }/${this.auth.getContractorInfo().contractor_id}`
    );
  }

  /**
   * Get System List
   * @returns
   */
  verifySystem(systemName: string | number) {
    return this.http.get(`${this.baseURL}/rhAPI/verifsystems/${systemName}`);
  }

  /**
   * Get Rooms
   * @param roomId
   * @returns
   */
  getRoom(roomId: string | number) : Observable<any> {
    return this.http.get(`${this.baseURL}/rhAPI/getRoom/${roomId}`);
  }

  /**
   * Edit Room
   * @param roomId
   * @param updatedRoom
   * @returns
   */
  editRoom(roomId: string | number, updatedRoom: any) {
    return this.http.post(
      `${this.baseURL}/rhAPI/editRoom/${roomId}`,
      updatedRoom
    );
  }

  /**
   * Delete Room
   * @param roomId
   * @returns
   */
  deleteRoom(roomId: string | number) {
    return this.http.post(`${this.baseURL}/rhAPI/deleteRoom/${roomId}`, {});
  }

  /**
   * Get One System
   * @returns
   */
  getSingleSystem(systemId: String | number) {
    return this.http.get(`${this.baseURL}/rhAPI/view_system/${systemId}`);
  }

  /**
   * Delete System
   * @param systemId
   * @returns
   */
  deleteSystem(systemId: String | number) {
    return this.http.post(
      `${this.baseURL}/rhAPI/delete_equipment/${systemId}`,
      {}
    );
  }

  /**
   * Delete System By Id
   * @param System
   * @returns
   */
  deleteSystemById(systemId: String | number) {
    return this.http.post(
      `${this.baseURL}/rhAPI/delete_System/${systemId}`,
      {}
    );
  }

  getSingleEquipment(equipmentId: String | number)  {
    return this.http.get(
      `${this.baseURL}/rhAPI/getOneEquipment/${equipmentId}`,{}
    );
  }

  /**
   * Register Desing before ading system
   * @param System
   * @returns
   */
  registerDesign(newSystem: singleSystem) {
    return this.http.post(`${this.baseURL}/rhAPI/update_designs2`, newSystem);
  }

  /**
   * Add New System
   * @param System
   * @returns
   */
  newSystem(newSystem: singleSystem) {
    return this.http.post(`${this.baseURL}/rhAPI/systems`, newSystem);
  }

  /**
   * Update System
   * @param updatedSystem
   * @returns
   */
  updateSystem(updatedSystem: singleSystem) {
    return this.http.post(`${this.baseURL}/rhAPI/updateSystem`, updatedSystem);
  }

  /**
   * Add New Room
   * @param Room
   * @returns
   */
  addNewRoom(newRoom: RoomEntity) {
    return this.http.post(`${this.baseURL}/rhAPI/addRoom`, newRoom);
  }

  uploadImageChecklist(fileName: string) {
    return this.http.post(`https://s3.amazonaws.com/inspexn/` + fileName, {});
  }

  roomFile(fileName: string, systemId: any) {
    let body = {
      roombyroomfile: `https://s3.amazonaws.com/inspexn/${fileName}`,
    };
    return this.http.post(
      `${this.baseURL}/rhAPI/systems/roomFile/${systemId}`,
      body
    );
  }
}
